@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.root {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 414px;
}

.buttonGroupWrapper {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
  margin-bottom: 16px;
}

.titleLabel {
  @include typography-v2-title-base;
}

.styledButtonGroup {
  [data-button-group] {
    @include border-radius-r2;
    width: 175px;
  }

  [data-button-group-item] {
    padding: 4px 8px;
  }
}

.flexRow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.chartTitleLabel {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.chartWrapper {
  opacity: 1;
  transition: opacity 800ms ease-in-out;
  min-height: 300px;
}

.styledButton {
  [data-button-text] {
    color: var(--text-primary);
  }
}
